export const READER_REQUEST_STATUSES = {
  sent: 0,
  received: 1,
  error: 2
};
